export default "__VITE_ASSET__ef4a0087__"